import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { PageInfoService, PageLink } from '@metronic/layout';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { API } from '@config/constants/api.constant';
import { IQRBatchBrandItem, IQRBatchForm_BrandItem, IQRBatchForm_SelectedBrand, ISelectedBrandFormat } from '../qr-products.interface';
import { InputListboxBrandComponent } from '../components/input-listbox-brand/input-listbox-brand.component';
import { BehaviorSubject } from 'rxjs';
import { UtilitiesService } from '@services/utilities.service';
import { QrProductsService } from '../qr-products.service';
import { ModalConfirmCreateComponent } from '../components/modal-confirm-create/modal-confirm-create.component';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { CustomsSnackbarComponent } from '@shared/components/customs-snackbar/customs-snackbar.component';
import { ModalConfirmCancelComponent } from '../components/modal-confirm-cancel/modal-confirm-cancel.component';

@Component({
  selector: 'app-qr-batch-add',
  templateUrl: './qr-batch-add.component.html',
  styleUrls: ['./qr-batch-add.component.scss'],
})
export class QrBatchAddComponent implements OnInit, AfterViewInit {
  @ViewChild('listboxBrandComponent') listboxBrandComponent: InputListboxBrandComponent;

  links: PageLink[] = [
    {
      title: 'Product Catalog',
      path: 'products/list-published',
      isActive: false,
    },
    {
      title: '',
      path: '',
      isActive: false,
      isSeparator: true,
    },
    {
      title: 'Qr Produk',
      path: 'products/list-qr-produk',
      isActive: false,
    },
    {
      title: '',
      path: '',
      isActive: false,
      isSeparator: true,
    },
    {
      title: 'Generate QR',
      path: '',
      isActive: true,
    },
  ];

  tableColumns = [
    {
      key: 'name',
      title: 'Nama Produk',
      isSortable: false,
    },
    {
      key: 'qty',
      title: 'QTY Qr',
      isSortable: false,
    },
    {
      key: 'action',
      title: 'Action',
      isSortable: false,
    },
  ];
  displayedColumns: string[];
  tableSourceBrand = new BehaviorSubject<IQRBatchBrandItem[]>([]);

  qrBatchForm = this.fb.group({
    batch_name: ['', Validators.compose([Validators.required, Validators.maxLength(100)])],
    list_brand: this.fb.array([], Validators.required),
  });

  selectedBrandToCreate = new BehaviorSubject<IQRBatchForm_SelectedBrand>({} as IQRBatchForm_SelectedBrand);
  @ViewChild('modalConfirmCreate') modalConfirmCreate: ModalConfirmCreateComponent;
  @ViewChild('modalConfirmCancel') modalConfirmCancel: ModalConfirmCancelComponent;

  totalQTY = new BehaviorSubject(0);

  configSnack: MatSnackBarConfig = {
    duration: 3000,
    horizontalPosition: 'center',
  };

  configSnackDelete: MatSnackBarConfig = {
    data: {
      text: 'Produk Berhasil dihapus',
      color: '#353535',
      ctaButton: true,
      ctaLabel: 'BATALKAN',
      ctaLabelColor: '#fff',
    },
    ...this.configSnack,
  };

  configSnackCancelDelete: MatSnackBarConfig = {
    data: {
      text: 'Berhasil mengembalikan 1 produk',
      color: '#353535',
      ctaButton: true,
      ctaLabel: 'OK',
      ctaLabelColor: '#fff',
    },
    ...this.configSnack,
  };

  MAX_NUMBER_BRAND = 5;
  MAX_NUMBER_COUNTER = 5500;

  configSnackMaxBrandLimit: MatSnackBarConfig = {
    data: {
      text: `Batas maksimal generate QR adalah ${this.MAX_NUMBER_BRAND} produk per-batch.`,
      color: '#CC4435',
      ctaButton: true,
      ctaLabel: 'OK',
      ctaLabelColor: '#fff',
    },
    ...this.configSnack,
  };

  constructor(
    private snackBar: MatSnackBar,
    private pageInfoService: PageInfoService,
    private fb: FormBuilder,
    private qrProductService: QrProductsService,
    public utilitiesService: UtilitiesService
  ) {}

  get formListBrand() {
    return <FormArray>this.qrBatchForm.controls['list_brand'];
  }

  getGenerateQty(idx: number) {
    return <FormControl>this.formListBrand.at(idx).get('generate_qty');
  }

  ngOnInit() {
    this.initPageInfo();
    this.setTableData();
  }

  ngAfterViewInit() {
    this.formListBrand.valueChanges.subscribe(() => {
      this.calculateTotalQty();
    });
  }

  initPageInfo() {
    this.pageInfoService.updateTitle('Generate Qr Batch', undefined, false);
    this.pageInfoService.updateBreadcrumbs(this.links);
  }

  setTableData() {
    this.displayedColumns = this.tableColumns.map((head) => head.key);
  }

  handleSelectedItems(data: BehaviorSubject<IQRBatchBrandItem[]>) {
    const _data = data.value;

    if (this.formListBrand.value.length === _data.length) return;

    this.tableSourceBrand.next(_data);
    this.addListBrand();
  }

  handleRemoveBrand(item: IQRBatchBrandItem, index: number) {
    let _source = this.tableSourceBrand.value;

    const snackDelete = this.snackBar.openFromComponent(CustomsSnackbarComponent, {
      ...this.configSnackDelete,
    });

    _source[index].selected = false;
    _source = _source.filter((val) => val.id !== item.id);

    // temp. save item value before deletion;
    // in case user cancel remove
    const _tempItemValue = this.getGenerateQty(index).value;

    this.tableSourceBrand.next(_source);
    this.removeListBrand(index);

    this.listboxBrandComponent.listSelectedItems.next(_source);

    snackDelete.afterDismissed().subscribe((resp) => {
      if (resp.dismissedByAction) {
        item.generate_qty = _tempItemValue;
        return this.handleCancelRemoveBrand(item, index);
      }
    });
  }

  addListBrand() {
    const data = this.tableSourceBrand.value;

    data.map((item, index) => {
      if (!this.itemExistInFormBrand(item)) {
        return this.addFormBrand(item, index);
      }
    });

    this.excludeCurrentSelectedBrand(data);
  }

  excludeCurrentSelectedBrand(data: IQRBatchBrandItem[]) {
    let currentListBrand = this.formListBrand.value as IQRBatchForm_BrandItem[];

    const _filteredData = currentListBrand.filter((_c) => {
      return !data.some((_d) => {
        return _c.brand_id === _d.id;
      });
    });

    if (_filteredData.length) {
      currentListBrand = currentListBrand.filter((item) => !_filteredData.some((filteredItem) => filteredItem.brand_id === item.brand_id));

      this.formListBrand.clear();
      currentListBrand.map((_c) => {
        const _brand = this.addBrandGroup(_c);
        this.formListBrand.push(_brand);
      });
    }
  }

  itemExistInFormBrand(item: IQRBatchBrandItem) {
    const currentListBrand = this.formListBrand.value as IQRBatchForm_BrandItem[];
    return currentListBrand.some((listItem) => {
      return item.id === listItem.brand_id;
    });
  }

  addFormBrand(item: IQRBatchBrandItem, index: number) {
    const brand = this.addBrandGroup({ brand_id: item.id, generate_qty: item.generate_qty });

    this.formListBrand.insert(index, brand);
    this.calculateTotalQty();
  }

  addBrandGroup(item: IQRBatchForm_BrandItem) {
    const { brand_id, generate_qty } = item;
    return this.fb.group({
      brand_id,
      generate_qty: [generate_qty, Validators.compose([Validators.required, Validators.min(1)])],
    });
  }

  removeListBrand(index: number) {
    this.formListBrand.removeAt(index);
  }

  handleSubmit() {
    const data = this.qrBatchForm.value.list_brand as IQRBatchForm_BrandItem[];
    const list = this.qrProductService.generateSelectedBrandFormat(data, this.tableSourceBrand.value);

    this.calculateTotalQty();

    this.selectedBrandToCreate.next({
      batch_name: this.qrBatchForm.value.batch_name as string,
      total_qty: this.totalQTY.value,
      list: list as ISelectedBrandFormat[],
    });

    return this.modalConfirmCreate.openConfirmDialog();
  }

  handleCancel = () => this.modalConfirmCancel.openDialog();

  shouldResetForm(val: boolean) {
    if (!val) return false;
    this.qrBatchForm.reset();
    this.tableSourceBrand.next([]);
    return this.qrProductService.routeToListPage();
  }

  calculateTotalQty() {
    let _total = 0;

    this.formListBrand.value.map((item: any) => {
      _total = _total + +item.generate_qty;
    });

    if (isNaN(_total)) {
      return;
    }

    this.totalQTY.next(_total);
  }

  handleCancelRemoveBrand(item: IQRBatchBrandItem, index: number) {
    const _source = this.tableSourceBrand.value;

    item.selected = true;
    _source.splice(index, 0, item);

    this.addFormBrand(item, index);

    this.tableSourceBrand.next(_source);
    this.listboxBrandComponent.listSelectedItems.next(_source);

    this.snackBar.openFromComponent(CustomsSnackbarComponent, {
      ...this.configSnackCancelDelete,
    });
  }

  handleOpenListBoxBrand() {
    if (!this.isAbleToAddProduct()) {
      return this.snackBar.openFromComponent(CustomsSnackbarComponent, {
        ...this.configSnackMaxBrandLimit,
      });
    }

    return this.listboxBrandComponent.open();
  }

  isAbleToAddProduct = () => this.formListBrand.value.length < this.MAX_NUMBER_BRAND;

  handleSyncData = () => this.listboxBrandComponent.open(false);

  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
  protected readonly API = API;
}
